import { render } from "./ConnectionButton.vue?vue&type=template&id=547dedcb&scoped=true"
import script from "./ConnectionButton.vue?vue&type=script&lang=js"
export * from "./ConnectionButton.vue?vue&type=script&lang=js"

import "./ConnectionButton.vue?vue&type=style&index=0&id=547dedcb&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547dedcb"]])

export default __exports__